import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import TxfJobViewModel from './TxfJobViewModel'
import styles from './TxfJobCard.sass'

interface Props {
  vm: TxfJobViewModel
}

export default observer(function TxfJobCard({ vm }: Props) {
  return (
    <div className={cx(styles.root)}>
      <Icon name="txf" size={32} />

      <div className={cx(styles.title)}>
        Your tax documents have been extracted
      </div>

      <div className={cx(styles.description)}>
        Review the extracted information and export to your tax software.{' '}
        <Tooltip
          placement="top"
          content={'Only works with 1040 individual tax returns.'}
        >
          <Icon name="info-blue" size={14} color={'var(--red400)'} />
        </Tooltip>
      </div>

      <button className={cx(styles.button)} onClick={() => vm.viewInTxf()}>
        Review & Export
      </button>
    </div>
  )
})
